var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"button",class:{'is-active': _vm.active},attrs:{"to":{name: _vm.route},"data-theme":_vm.theme}},[_c('app-icon',{staticClass:"button-icon",attrs:{"icon":_vm.icon}}),_c('div',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }